window.addEventListener("DOMContentLoaded", function (event) {
  const containers = document.querySelectorAll(".tabs-container");
  containers.forEach(function (tabSection) {
    // adda the tab index attribute to each button.
    const tabButtons = tabSection.querySelectorAll(
      ".tab-title-container .tab-button"
    );
    tabButtons.forEach(function (el, idx) {
      el.setAttribute("data-tab", idx);
    });

    // Preselect first tab if not any
    const hasActive = tabSection.querySelector(".active");
    if (!hasActive) {
      activateTab(tabSection, 0);
    }
    const tabCount = tabSection.length;
    const buttonsContainer = tabSection.querySelector(".tab-title-container");

    buttonsContainer.addEventListener("click", function (ev) {
      const index = ev.target.getAttribute("data-tab");
      activateTab(tabSection, index);
    });
  });
});

const activateTab = (tab, index) => {
  const tabIndex = parseInt(index);
  const tabs = tab.querySelectorAll(".tab");
  const tabButtons = tab.querySelectorAll(".tab-title-container .tab-button");
  for (let i = 0; i < tabs.length; i++) {
    tabButtons[i].parentNode.classList.remove("active");
    tabs[i].classList.remove("active");
    if (tabIndex === i) {
      tabButtons[i].parentNode.classList.add("active");
      tabs[i].classList.add("active");
    }
  }
};
